import { ChangeEvent, useEffect, useState } from 'react';
import { Modal, TextField, Button, Autocomplete } from '@mui/material';
import { Footer, ModalBox, ModalH2 } from './ModalPecaStyle';
import { InputMoney } from '../../../../shared/components/InputMoney';
import { ProdutoRequest } from '../../../../controllers/Types';
import ProdutoController from '../../../../controllers/ProdutoController';
import * as Icon from '@mui/icons-material';
import { ProdutoCadastrar } from '../../../../routes/RoutesNames';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setFieldValue: any;
  values: any;
}

interface Produto {
  prod_id: number;
  prod_descricao: string;
  prodID_promatec?: string;
  preco_venda: number;
}

const ModalPeca = ({ open, onClose, setFieldValue, values }: ModalProps) => {
  const [produto, setProduto] = useState<Produto | null>(null);
  const [produtoFeched, setProdutoFeched] = useState<any | null>(null);
  const [produtos, setProdutos] = useState([]);
  const [quantidade, setQuantidade] = useState(1);
  const [valor, setValor] = useState('0.00');
  const [desconto, setDesconto] = useState('0.00');
  const [valorTotal, setValorTotal] = useState('0.00');
  const [searchText, setSearchText] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [blockProduto, setBlockProduto] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [showButtonAdd, setShowButtonAdd] = useState(false);
  const [errorProduto, setErrorProduto] = useState(false);

  const [errorDesconto, setErrorDesconto] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (values?.selectedPeca?.peca) {

        try {
          const response = await ProdutoController.ListarUnico(values.selectedPeca.peca.pecaId);
          const produtoUnico = response.Data;
          setProduto(produtoUnico);
          setProdutoFeched(produtoUnico);
          setQuantidade(values.selectedPeca?.peca?.quantidade);
          setValor(values.selectedPeca?.peca?.valorUnitario);
          setDesconto(values.selectedPeca?.peca?.desconto);
          setValorTotal(values.selectedPeca?.peca?.valorTotal);
          setIsUpdateMode(true);
          // setBlockProduto(true);
        } catch (error) {
          console.error("Erro ao buscar produto:", error);
        }
      } else {
        setIsUpdateMode(false);
      }
    };

    fetchData();
  }, [values?.selectedPeca, open]);

  useEffect(() => {
    const fetchProdutos = async () => {
      const request: ProdutoRequest = {
        Descricao: searchText,
        CodigoBarras: '',
        Tipo: '',
        PartNumber: '',
        Grupo: '',
      };
      const response = await ProdutoController.Listar(request);
      if (response.StatusCode === 200) {
        const lista = Array.isArray(response.Data) ? response.Data : [];
        setShowButtonAdd(lista.length === 0);
        setProdutos(response.Data.map((item: Produto) => ({ id: item.prod_id, label: `${item.prodID_promatec} - ${item.prod_descricao}`, ...item })));
      }
    };

    if (open && inputValue.length >= 1) {
      fetchProdutos();
    } else {
      setProdutos([]);
    }
  }, [open, inputValue, searchText]);

  const handleInputChange = (event: any, newInputValue: any) => {
    console.log(event);
    setInputValue(newInputValue);
    setSearchText(newInputValue);
  };


  const handleSave = () => {
    let hasError = false;

    if (!produto) {
      setErrorProduto(true);
      hasError = true;
    } else {
      setErrorProduto(false);
    }

    if (hasError) return;

    const newItem = {
      pecaId: produto?.prod_id,
      produto: produto?.prod_descricao,
      quantidade,
      desconto,
      valorUnitario: valor,
      valorTotal,
    };

    let existingIndex = -1;
    if (isUpdateMode) {
      existingIndex = values.pecasjson.findIndex(
        (item: any) => item.peca.pecaId === produtoFeched.prod_id
      );
    } else {
      existingIndex = values.pecasjson.findIndex((item: any) => item.peca.pecaId === newItem.pecaId);
    }

    let updatedPecasJson;
    if (existingIndex !== -1) {
      updatedPecasJson = [...values.pecasjson];
      updatedPecasJson[existingIndex] = { peca: { ...updatedPecasJson[existingIndex].peca, ...newItem } };
    } else {
      updatedPecasJson = [...values.pecasjson, { peca: newItem }];
    }

    setFieldValue('pecasjson', updatedPecasJson);
    resetFormFields();
  };

  const handleClose = () => {
    resetFormFields();
  };

  const resetFormFields = () => {
    setProduto(null);
    setQuantidade(1);
    setInputValue('');
    setSearchText('');
    setValor('0.00');
    setDesconto('0.00');
    setValorTotal('0.00');
    setBlockProduto(false);
    setFieldValue('selectedPeca', null);
    onClose();
  };


  const handleProdutoChange = (_: any, newValue: any) => {
    setProduto(newValue);
    setQuantidade(1);
    if (newValue) {
      const preco = Number(newValue.preco_venda || 0);
      setValor(preco.toFixed(2));
      setDesconto('0.00');
      // valorTotal e recalculado pelo useEffect (valor unitario x quantidade - desconto)
    } else {
      setValor('0.00');
      setDesconto('0.00');
      setValorTotal('0.00');
    }
  };

  const handleQuantidadeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newQuantidade = parseInt(event.target.value, 10) || 1;
    setQuantidade(newQuantidade);
    // NAO sobrescreve o valor unitario. O total e recalculado pelo useEffect
    // abaixo: valor unitario x quantidade - desconto.
  };

  useEffect(() => {
    calculateTotal();
  }, [valor, desconto, quantidade]);

  const handleValorBlur = (event: any) => {
    const novoValor = parseFloat(event.target.value.replace('R$ ', '').replace(/\./g, '').replace(',', '.')) || 0;
    setValor(novoValor.toFixed(2));
  };

  const handleDescontoBlur = (event: any) => {
    const novoDesconto = parseFloat(event.target.value.replace('R$ ', '').replace(/\./g, '').replace(',', '.')) || 0;

    if (novoDesconto > parseFloat(valor)) {
      setErrorDesconto(true);
      event.target.focus();
    } else {
      setErrorDesconto(false);
      setDesconto(novoDesconto.toFixed(2));
      calculateTotal();
    }
  };

  const handleDescontoChange = (values: { floatValue?: number }) => {
    const novoDesconto = values.floatValue || 0;

    if (novoDesconto > parseFloat(valor)) {
      setErrorDesconto(true);
    } else {
      setErrorDesconto(false);
      setDesconto(novoDesconto.toFixed(2));
      calculateTotal();
    }
  };


  const calculateTotal = () => {
    const numValor = parseFloat(valor.toString().replace(',', '.')) || 0;
    const numDesconto = parseFloat(desconto.toString().replace(',', '.')) || 0;
    const total = numValor * quantidade - numDesconto;
    setValorTotal(total.toFixed(2));
  };

  const handleAddProduto = () => {
    window.open(ProdutoCadastrar, '_black')
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
        <ModalH2>Cadastro de Peças</ModalH2>
        <Autocomplete
          options={produtos}
          filterOptions={(x) => x}
          getOptionLabel={(option) => option?.prodID_promatec
            ? `${option.prodID_promatec} - ${option.prod_descricao}`
            : option?.prod_descricao || ''}
          value={produto}
          onChange={handleProdutoChange}
          inputValue={inputValue}
          onInputChange={handleInputChange}
          isOptionEqualToValue={(option, value) => option.prod_id === value?.prod_id}
          renderOption={(props, option) => (
            <li {...props} key={option.prod_id}>{option.prod_descricao}</li>
          )}
          disabled={blockProduto}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Produto"
              error={errorProduto}
              helperText={errorProduto ? "Selecione um produto" : ""}
            />
          )}
        />
        <TextField
          label='Quantidade'
          type='number'
          fullWidth
          value={quantidade}
          onChange={handleQuantidadeChange}
          sx={{ mt: 2 }}
          inputProps={{ min: 1 }}
        />
        <InputMoney
          label='Valor'
          name='Valor'
          handleBlur={handleValorBlur}
          value={valor}
          sx={{ mt: 2 }}
          fullWidth
        />

        <InputMoney
          label='Desconto'
          name='Desconto'
          value={desconto}
          handleBlur={handleDescontoBlur}
          handleChange={handleDescontoChange}
          sx={{ mt: 2 }}
          fullWidth
          hasError={errorDesconto}
          error={errorDesconto ? 'Desconto não pode ser maior que o valor' : ''}
        />
        <InputMoney
          label='Valor Total'
          value={valorTotal}
          name='valorTotal'
          sx={{ mt: 2 }}
          fullWidth
          disabled={true}
        />
        <Footer>
          <Button onClick={handleClose} color='error'>Cancelar</Button>
          {showButtonAdd && (
            <Button
              onClick={() => handleAddProduto()}
              color='info'
              startIcon={<Icon.Create />}
            >
              Criar
            </Button>
          )}
          <Button onClick={handleSave} variant='contained' color='primary'>Salvar</Button>
        </Footer>
      </ModalBox>
    </Modal>
  );
};

export default ModalPeca;
